export const functions = {
    getPathValue,
    isDate,
    isNullOrEmpty,
    utcToLocalTimestamp
}

export function getPathValue(path, obj) {
    return path.split('.').reduce(function (a, b) {
        return a && a[b]
    }, obj)
}

export function isDate (string) {
    return (new Date(string) !== 'Invalid Date') && !isNaN(new Date(string)) && !(typeof string === 'number')
}

export function isNullOrEmpty(str) {
    return !str || str.trim() === "";
}


export function utcToLocalTimestamp(dateString) {
    let isoUtcString = dateString.replace(' ', 'T');

    if (!/[zZ]|[+-]\d{2}:\d{2}$/.test(isoUtcString)) {
        isoUtcString += 'Z';
    }

    const localDate = new Date(isoUtcString);
    return localDate.getTime();
}
